import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["innerHTML"]

import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { useStore } from 'vuex';
import Modal from '@/components/Modal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SystemRequirmentsModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

store.dispatch('Common/getSystemRequirements');

const sysReq = computed(() => store.getters['Common/systemRequirementsCurrentLocaleTranslate']);

const { t } = useI18n();
const props = __props;

const emit = __emit;

const handleClose = () => emit('close', !props.isOpen);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          width: "500",
          onClose: handleClose
        }, {
          header: _withCtx(() => [
            _createElementVNode("h2", null, _toDisplayString(_unref(t)("systemRequirements.systemRequirements")), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", { innerHTML: sysReq.value }, null, 8, _hoisted_1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})